<template>
  <div class="h3 p-2 bg-gray-50 shadow-md">
    <span class="hidden lg:inline mr-2">{{ $t(title) }}</span>
    <span v-if="name" class="italic text-gray-400">'{{name}}'</span>
  </div>
</template>

<script>
export default {
  name: 'LmFormHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    }
  }
}
</script>
